import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import React from "react";

const HandleRenderOption = (props, option) => {
  const newProps = props?.title || props;
  const matches = match(newProps, option.inputValue?.trim(), {
    insideWords: true
  });
  const parts = parse(newProps, matches);

  const highlightStyle = {
    fontWeight: 700
  };

  return (
    <li>
      {parts.map((part, index) => (
        <span key={index} style={part.highlight ? highlightStyle : {}}>
          {part.text}
        </span>
      ))}
    </li>
  );
};

export default HandleRenderOption;
